<template>
  <router-view/>
</template>
<style lang="scss">
@import '~@/sass/main.scss';
@import '../node_modules/sweetalert2/dist/sweetalert2.min.css';

#app {
  font-family: 'Source Sans Pro', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 1.25rem;
}
.swal2-container {
  font-family: 'Source Sans Pro', Avenir, Helvetica, Arial, sans-serif;
}
body {
  margin: 0;
  background: var(--va-background);
}
.va-data-table__table-th div{
  font-size: 0.9rem;
}
.va-data-table__table-td{
  font-size: 1rem;
  }
.va-modal__title{
  font-size: 1rem;
  color:#a3b21e;
}
.va-list .va-list-item-label--caption{
    color: #686767;
  }
  .va-input-wrapper--labeled .va-input-wrapper__label{
    font-size: 0.7rem !important;
  }
  .text-regular{
  font-size: 1.25rem !important;
}
</style>
